import { MAIN_SERVER, WS_URL } from "api/ApiConstants";
import dashRoutes from "routes";
import axios from "axios";

export const getSiteComponents = (appConst, siteName) => {
    return new Promise((resolve, reject) => {
        getSiteConstants(appConst, siteName).then(async (temp) => {
            var loginPage = null;
            switch (temp.identifier) {
                case "gostree": {
                    const colorPaletteImport = await import("assets/Gostree/js/ColorPalette");
                    temp.colors = colorPaletteImport.colors;
                    const faviconImport = await import(
                        "assets/Gostree/images/favicons/favicon.ico"
                    );
                    temp.favicon = faviconImport.default;
                    const companyLogoImport = await import(
                        "assets/Gostree/images/company_logo.svg"
                    );
                    temp.companyLogo = companyLogoImport.default;
                    const flavLoaderImport = await import(
                        "assets/Gostree/images/loaders/flight_avail_loader.gif"
                    );
                    temp.flavLoader = flavLoaderImport.default;
                    temp.comLoader = flavLoaderImport.default;
                    const loginLoaderImport = await import(
                        "assets/Gostree/images/loaders/geebaku-loading.gif"
                    );
                    temp.loginLoader = loginLoaderImport.default;
                    const postLoginNavImport = await import(
                        "components/Navbars/PostLoginNavBar.Gostree"
                    );
                    temp.postLoginNavbar = postLoginNavImport.default;
                    const preLoginNavImport = await import(
                        "components/Navbars/PreLoginNavBar.Gostree"
                    );
                    temp.preLoginNavbar = preLoginNavImport.default;
                    const homepageNavImport = await import(
                        "components/LandingPage/Gostree/HomePageNavbar"
                    );
                    temp.homePageNavbar = homepageNavImport.default;
                    const footerImport = await import(
                        "components/LandingPage/Gostree/FooterSection"
                    );
                    temp.pageFooter = footerImport.default;
                    temp.homePageFooter = footerImport.default;
                    const tncImport = await import(
                        "components/LandingPage/Gostree/siteinfo/TermsAndConditions"
                    );
                    temp.termsAndConditions = tncImport.default;
                    const cnrImport = await import(
                        "components/LandingPage/Gostree/siteinfo/CancellationAndRefund"
                    );
                    temp.cancellationAndRefund = cnrImport.default;
                    const prvPolImport = await import(
                        "components/LandingPage/Gostree/siteinfo/PrivacyPolicy"
                    );
                    temp.privacyPolicy = prvPolImport.default;
                    const prcPolImport = await import(
                        "components/LandingPage/Gostree/siteinfo/PricingPolicy"
                    );
                    temp.pricingPolicy = prcPolImport.default;
                    const aboutImport = await import(
                        "components/LandingPage/Gostree/siteinfo/AboutUsPage"
                    );
                    temp.aboutUs = aboutImport.default;
                    const contactImport = await import(
                        "components/LandingPage/Gostree/siteinfo/ContactUsPage"
                    );
                    temp.contactUs = contactImport.default;
                    const scrollToTopImport = await import(
                        "components/LandingPage/Gostree/ScrollToTopComp"
                    );
                    temp.scrollToTop = scrollToTopImport.default;
                    const loginPageImport = await import(
                        "components/LandingPage/Gostree/LoginSection"
                    );
                    loginPage = loginPageImport.default;
                    const landPageBaseImport = await import(
                        "components/LandingPage/Gostree/LandingPageBase"
                    );
                    temp.landingPageBase = landPageBaseImport.default;
                    break;
                }

                case "oarilocal":
                case "oari":
                case "noCodes": {
                    const colorPaletteImport = await import("assets/WhiteLabels/Geebaku/NoCodes/js/ColorPalette");
                    temp.colors = colorPaletteImport.colors;
                    const faviconImport = await import(
                        "assets/WhiteLabels/Geebaku/NoCodes/images/favicons/favicon.ico"
                    );
                    temp.favicon = faviconImport.default;
                    const companyLogoImport = await import(
                        "assets/WhiteLabels/Geebaku/NoCodes/images/company_logo.png"
                    );
                    temp.companyLogo = companyLogoImport.default;
                    const flavLoaderImport = await import(
                        "assets/WhiteLabels/Geebaku/NoCodes/images/loaders/loader.gif"
                    );
                    temp.flavLoader = flavLoaderImport.default;
                    temp.comLoader = flavLoaderImport.default;
                    const loginLoaderImport = await import(
                        "assets/WhiteLabels/Geebaku/NoCodes/images/loaders/ticket.gif"
                    );
                    temp.loginLoader = loginLoaderImport.default;
                    const postLoginNavImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Navbar/PostLoginNavBar"
                    );
                    temp.postLoginNavbar = postLoginNavImport.default;
                    const preLoginNavImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Navbar/PreLoginNavBar"
                    );
                    temp.preLoginNavbar = preLoginNavImport.default;
                    const homepageNavImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/HomePageNavbar"
                    );
                    temp.homePageNavbar = homepageNavImport.default;
                    const footerImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/FooterSection"
                    );
                    temp.pageFooter = footerImport.default;
                    temp.homePageFooter = footerImport.default;
                    const tncImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/siteinfo/TermsAndConditions"
                    );
                    temp.termsAndConditions = tncImport.default;
                    const cnrImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/siteinfo/CancellationAndRefund"
                    );
                    temp.cancellationAndRefund = cnrImport.default;
                    const prvPolImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/siteinfo/PrivacyPolicy"
                    );
                    temp.privacyPolicy = prvPolImport.default;
                    const prcPolImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/siteinfo/PricingPolicy"
                    );
                    temp.pricingPolicy = prcPolImport.default;
                    const aboutImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/siteinfo/AboutUsPage"
                    );
                    temp.aboutUs = aboutImport.default;
                    const contactImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/siteinfo/ContactUsPage"
                    );
                    temp.contactUs = contactImport.default;
                    const scrollToTopImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/ScrollToTopComp"
                    );
                    temp.scrollToTop = scrollToTopImport.default;
                    const loginPageImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/LoginSection"
                    );
                    loginPage = loginPageImport.default;
                    const landPageBaseImport = await import(
                        "components/WhiteLabels/Geebaku/NoCodes/Landingpage/LandingPageBase"
                    );
                    temp.landingPageBase = landPageBaseImport.default;
                    break;
                }
            }
            dashRoutes.push({
                path: "/login",
                name: "Login",
                mini: "L",
                layout: "/auth",
                hidden: false,
                component: loginPage,
                type: "all"
            });
            temp.dashRoutes = dashRoutes;
            resolve(temp);
        }).catch((error) => {
            console.error("Error", error);
            reject(error);
        });
    });
};

export const getSiteConstants = (appConst, siteName) => {
    return new Promise((resolve, reject) => {
        checkPartnerSite(
            {
                // partnerId: appConst.B2BOnly ? 1002 : 1001,
                partnerSite: siteName,
                enabled: true,
            },
            (response) => {
                if (response.success && response.data?.authStatus) {
                    appConst.name = response.data.partnerSiteMst?.name;
                    appConst.title = response.data.partnerSiteMst?.title;
                    appConst.ccName = response.data.partnerSiteMst?.ccName;
                    appConst.identifier = response.data.partnerSiteMst?.identifier;
                    appConst.country = response.data.partnerSiteMst?.country;
                    appConst.countryDialCode =
                        response.data.partnerSiteMst?.countryDialCode;
                    appConst.domainName = response.data.partnerSiteAddress?.siteaddress;
                    appConst.domainAlias =
                        "www." + response.data.partnerSiteAddress?.siteaddress;
                    appConst.sslEnabled = response.data.partnerSiteAddress?.ssl_enabled;
                    appConst.siteEnabled = response.data.partnerSiteAddress?.enabled;
                    appConst.clientId = response.data.partnerClientMst?.client_id;
                    appConst.b2BOnly = response.data.partnerSiteMst?.b2BOnly;
                    appConst.shareNow = response.data.partnerSiteMst?.shareNow;
                    appConst.flightConvenienceFeeSectorwise =
                        response.data.partnerSiteMst?.flightConvenienceFeeSectorwise;
                    appConst.holidaysFormShow =
                        response.data.partnerSiteMst?.holidaysFormShow;
                    appConst.hotelFilterOpen =
                        response.data.partnerSiteMst?.hotelFilterOpen;
                    appConst.hotelPriceRoundOff =
                        response.data.partnerSiteMst?.hotelPriceRoundOff;
                    appConst.hotelRatingsLowToHigh =
                        response.data.partnerSiteMst?.hotelRatingsLowToHigh;
                    appConst.isWhitelabelEnabled =
                        response.data.partnerSiteMst?.isWhitelabelEnabled;
                    appConst.savedFlightPax =
                        response.data.partnerSiteMst?.savedFlightPax;
                    appConst.shareNow = response.data.partnerSiteMst?.shareNow;
                    appConst.aepsPipe = response.data.partnerSiteMst?.aepsPipe;
                    appConst.dmtPipe = response.data.partnerSiteMst?.dmtPipe;
                    appConst.serviceAvailed =
                        response.data.partnerSiteMst?.serviceAvailed;

                    let i = 0;
                    for (let geoContact of response.data.partnerSiteMst
                        .locationAndContactList) {
                        if (i === 0) {
                            appConst.latitude = geoContact?.latitude;
                            appConst.longitude = geoContact?.longitude;
                            appConst.countryName = geoContact?.countryName;
                            appConst.city = geoContact?.city;
                        } else {
                            appConst[i < 10 ? "country0" + i : "country" + i] =
                                geoContact?.country;
                            appConst[
                                i < 10 ? "countryDialCode0" + i : "countryDialCode" + i
                            ] = geoContact?.countryDialCode;
                            appConst[i < 10 ? "latitude0" + i : "latitude" + i] =
                                geoContact?.latitude;
                            appConst[i < 10 ? "longitude0" + i : "longitude" + i] =
                                geoContact?.longitude;
                            appConst[i < 10 ? "countryName0" + i : "countryName" + i] =
                                geoContact?.countryName;
                            appConst[i < 10 ? "city0" + i : "city" + i] = geoContact?.city;
                        }
                        let j = 0;
                        for (let contact of geoContact.contactList) {
                            if (i === 0) {
                                if (j === 0) {
                                    appConst.supportEmail = contact?.supportEmail
                                        ? contact.supportEmail
                                        : "";
                                    appConst.infoEmail = contact?.infoEmail
                                        ? contact.infoEmail
                                        : "";
                                    appConst.supportContact = contact?.supportContact
                                        ? contact.supportContact
                                        : "";
                                    appConst.supportContactView = contact?.supportContact
                                        ? formatPhoneNumber(contact.supportContact)
                                        : "";
                                    appConst.infoContact = contact?.infoContact
                                        ? contact.infoContact
                                        : "";
                                    appConst.infoContactView = contact?.infoContact
                                        ? formatPhoneNumber(contact.infoContact)
                                        : "";
                                    appConst.address = {
                                        office: contact?.office,
                                        register: contact?.register,
                                    };
                                    appConst.waContact = contact?.wacontact;
                                } else {
                                    appConst[j < 10 ? "supportEmail0" + j : "supportEmail" + j] =
                                        contact?.supportEmail ? contact.supportEmail : "";
                                    appConst[j < 10 ? "infoEmail0" + j : "infoEmail" + j] =
                                        contact?.infoEmail ? contact.infoEmail : "";
                                    appConst[
                                        j < 10 ? "supportContact0" + j : "supportContact" + j
                                    ] = contact?.supportContact ? contact.supportContact : "";
                                    appConst[
                                        j < 10
                                            ? "supportContactView0" + j
                                            : "supportContactView" + j
                                    ] = contact?.supportContact
                                            ? formatPhoneNumber(contact.supportContact)
                                            : "";
                                    appConst[j < 10 ? "infoContact0" + j : "infoContact" + j] =
                                        contact?.infoContact ? contact.infoContact : "";
                                    appConst[
                                        j < 10 ? "infoContactView0" + j : "infoContactView" + j
                                    ] = contact?.infoContact
                                            ? formatPhoneNumber(contact.infoContact)
                                            : "";
                                    appConst.address[j < 10 ? "office0" + j : "office" + j] =
                                        contact?.office;
                                    appConst.address[j < 10 ? "register0" + j : "register" + j] =
                                        contact?.office;
                                    appConst.waContact = contact?.wacontact;
                                }
                            } else {
                                appConst[j < 10 ? "supportEmail0" + j : "supportEmail" + j] =
                                    contact?.supportEmail ? contact.supportEmail : "";
                                appConst[j < 10 ? "infoEmail0" + j : "infoEmail" + j] =
                                    contact?.infoEmail ? contact.infoEmail : "";
                                appConst[
                                    j < 10 ? "supportContact0" + j : "supportContact" + j
                                ] = contact?.supportContact ? contact.supportContact : "";
                                appConst[
                                    j < 10 ? "supportContactView0" + j : "supportContactView" + j
                                ] = contact?.supportContact
                                        ? formatPhoneNumber(contact.supportContact)
                                        : "";
                                appConst[j < 10 ? "infoContact0" + j : "infoContact" + j] =
                                    contact?.infoContact ? contact.infoContact : "";
                                appConst[
                                    j < 10 ? "infoContactView0" + j : "infoContactView" + j
                                ] = contact?.infoContact
                                        ? formatPhoneNumber(contact.infoContact)
                                        : "";
                                if (j === 0) {
                                    appConst.address = {
                                        office: contact?.office,
                                        register: contact?.register,
                                    };
                                } else {
                                    appConst[i < 10 ? "address0" + i : "address" + i] = {
                                        [j < 10 ? "office0" + j : "office" + j]: contact?.office,
                                        [j < 10 ? "register0" + j : "register" + j]:
                                            contact?.register,
                                    };
                                }
                                appConst.waContact = contact?.wacontact;
                            }
                            j++;
                        }
                        i++;
                    }
                    // console.log("appConst", appConst);
                    resolve(appConst);
                } else {
                    reject({ msg: "Failed to authenticate website" });
                }
            },
            (error) => {
                console.error("Error checking partner site address", error);
                reject({ msg: JSON.stringify(error) });
            }
        );
    });
};

const checkPartnerSite = (params, responseCallBack, errorCallBack) => {
    sendHttpRequest(
        MAIN_SERVER + WS_URL + "/api/v2/partner-site/check-partner-site",
        params,
        responseCallBack,
        errorCallBack
    );
};

async function sendHttpRequest(
    methodName,
    params,
    responseCallBack,
    errorCallBack
) {
    axios.interceptors.response.use(
        (response) => {
            if (response.status == 401) {
                alert("You are not authorized");
            }
            return response;
        },
        (error) => {
            console.error("error");
            console.error(error);
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error.message);
        }
    );

    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    };

    axios
        .post(methodName, params, {
            headers: headers,
        })
        .then((res) => {
            if (res && res.message != "Unauthorized") {
                return responseCallBack(res.data);
            } else {
                console.error(methodName + " error", res);
            }
        })
        .catch((error) => {
            if (
                (error && typeof error == "string" && error != "Unauthorized") ||
                (typeof error == "object" && error.message != "Unauthorized")
            ) {
                return errorCallBack(error);
            } else {
                console.error(methodName + " error", error);
            }
        });
}

function formatPhoneNumber(phoneNumber) {
    if (phoneNumber === "") {
        return "";
    }
    // Remove all non-digit characters
    const cleaned = phoneNumber.replace(/\D/g, "");

    // Check the length of the cleaned number
    if (cleaned.length < 10) {
        return phoneNumber;
    }

    // Format the number based on its length
    if (cleaned.length === 10) {
        // Standard US format: (XXX) XXX-XXXX
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
            6
        )}`;
    }
    // else if (cleaned.length === 11) {
    //   // Format with country code: +X (XXX) XXX-XXXX
    //   return `+${cleaned[0]} (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    // }
    else {
        // For longer numbers, group in blocks of 3, except the last 4 digits
        let formatted = cleaned.slice(0, -10);
        formatted += ` (${cleaned.slice(-10, -7)}) `;
        formatted += cleaned.slice(-7, -4) + "-";
        formatted += cleaned.slice(-4);
        return formatted;
    }
}
